export enum SocialNetworkStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}
